import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faGithub,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./Contact.css";

export default function Contact() {
  const email = "iamsusanna.b@gmail.com";

  return (
    <div>
      <div className="container-custom contact">
        <h2>Contact</h2>
        <div className="d-md-flex justify-content-between">
          <a href={`mailto:${email}`}>
            <FontAwesomeIcon icon={faEnvelope} className="fa-brands" />{" "}
          </a>
          <a
            href="https://github.com/shoproizoshlo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} className="fa-brands" />
          </a>
          <a
            href="https://www.linkedin.com/in/susanna-brechko/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} className="fa-brands" />
          </a>

          <a
            href="https://twitter.com/suereact/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faXTwitter} className="fa-brands" />
          </a>
        </div>
      </div>
    </div>
  );
}
